const ViewTrackingIcon = (props) => {
  const { className = "w-6 h-6", onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      title="Tracking"
      onClick={onClick}
    >
      <mask id="mask0_454_38437" maskUnits="userSpaceOnUse" x="1" y="4" width="22" height="16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17.5C8.21 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.79 17.5 12 17.5Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_454_38437)">
        <rect x="1" y="4" width="101" height="101" fill="currentColor" />
      </g>
      <mask id="mask1_454_38437" maskUnits="userSpaceOnUse" x="7" y="7" width="10" height="10">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5ZM12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_454_38437)">
        <rect x="7" y="7" width="101" height="101" fill="currentColor" />
      </g>
    </svg>
  );
};

export default ViewTrackingIcon;
